import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import {
  faSearch,
  faTicketAlt,
  faGenderless,
  faMars,
  faVenus,
  faGlobe,
  faPlay,
  faTimes
} from '@fortawesome/free-solid-svg-icons';

import {
  faCalendarAlt,
  faClock,
  faMoneyBillAlt
} from '@fortawesome/free-regular-svg-icons';

library.add(
  fab,
  faSearch,
  faCalendarAlt,
  faClock,
  faMoneyBillAlt,
  faTicketAlt,
  faGenderless,
  faMars,
  faVenus,
  faGlobe,
  faPlay,
  faTimes
);
